var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"live-cast"},[_c('video',{ref:"liveCastVideo",staticClass:"video mx-auto d-block",attrs:{"id":"liveCast","autoplay":"","controls":""}}),_c('media-status',{attrs:{"media":_vm.media}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }